module.exports = __webpack_public_path__ + "static/media/chor2.e77ac2f7.jpg";